import { styled } from '@mui/system'
import BHActionAddToCart from '../../../molecules/action-add-to-cart'
import Button from '../../../molecules/button'
import Typography from '../../../atoms/typography'
import { Block } from '../../../particles/cms-block'
import {
	BasePrice,
	DefaultPrice,
	DiscountPercentage,
	SpecialPrice,
} from '@bluheadless/ui/src/molecules/price/price.styled'
import { ProductList } from '@bluheadless/ui/src/organisms/product/sidebar/related-attributes.styled'

const shouldForwardProp = (prop) => !['isSticky'].includes(prop)

const ButtonAddToCart = styled(BHActionAddToCart, { shouldForwardProp })`
	${({ isSticky }) => isSticky && 'border-radius: 0;'}
	${({ theme }) => theme.breakpoints.down('lg')} {
		${({ isSticky, theme }) => isSticky && `font-size: ${theme.typography.pxToRem(12)};`}
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		${({ isSticky }) => isSticky && `min-width: 315px;`}
	}
`

const ButtonOutOfStock = styled(Button, { shouldForwardProp })`
	padding: ${({ theme }) => theme.spacing(0, 1)};
	font-size: var(--size-big);
	white-space: nowrap;
	${({ isSticky }) => isSticky && 'border-radius: 0;'}
	${({ theme }) => theme.breakpoints.between('md', 1200)} {
		font-size: var(--size-base);
	}
`

const TypographyStyled = styled(Typography)`
	margin-top: ${({ theme }) => theme.spacing(3)};
	color: ${({ theme }) => theme.palette.grey.main};
`

const Title = styled(Typography)`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	${({ theme }) => theme.breakpoints.down('lg')} {
		width: 60%;
	}
`

const PreOrderDescription = styled(Block)`
	color: ${({ theme }) => theme.palette.grey.main};
`

export const RightWrapper = styled('div')`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: var(--spacing-1);
	.oos-btn {
		font-size: var(--size-small);
	}

	${({ theme }) => theme.breakpoints.down('xl')} {
		flex-basis: 60%;
		width: 60%;
	}

	${({ theme }) => theme.breakpoints.down('sm')} {
		width: 100%;
		justify-content: space-between;
		flex-basis: 100%;
		.add-to-cart,
		.oos-btn {
			width: 100%;
		}
	}

	${({ theme }) => theme.breakpoints.up('xsm')} {
		.oos-btn {
			font-size: var(--size-medium);
		}
	}

	${ButtonAddToCart} {
		min-width: 0;
		padding: 9px 20px;
	}

	.MuiSelect-select {
		${({ theme }) => theme.breakpoints.up('sm')} {
			min-width: 110px !important;
		}
		${({ theme }) => theme.breakpoints.up('lg')} {
			min-width: 150px !important;
		}
		${({ theme }) => theme.breakpoints.up('xl')} {
			min-width: 200px !important;
		}
	}

	${ProductList} {
		margin-top: 0 !important;
	}
`

const ButtonsActionWrapper = styled('div', { shouldForwardProp })`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: ${({ theme }) => theme.spacing(3)};
	${({ theme, isSticky }) =>
		isSticky
			? `
		gap: calc(var(--spacing) * 2);
		margin: ${theme.spacing(1)};
		flex-wrap: nowrap;
		flex-direction: column;

		${RightWrapper} {
			flex-wrap: wrap;
			flex-direction: row;
			> div {
				width: 48%;
			}
		}
	`
			: `${RightWrapper} {
			width: 100%;
		}`}

	${({ theme }) => theme.breakpoints.up('sm')} {
		${({ isSticky }) =>
			isSticky &&
			`flex-direction: row;
				${RightWrapper} {
					> div {
						width: auto;
					}
				}
		`}
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		${({ theme, isSticky }) => isSticky && `margin: ${theme.spacing(3, 2)};`}

		${({ theme, isSticky }) =>
			isSticky
				? `
		margin: ${theme.spacing(2)};

		${RightWrapper} {
			> div {
				width: 27%;
			}
		}
	`
				: `${RightWrapper} {
			width: 100%;
		}`}
	}
`

export const LeftWrapper = styled('div')`
	display: flex;
	align-items: center;
	gap: var(--spacing-4);

	${DefaultPrice}, ${BasePrice}, ${SpecialPrice}, ${DiscountPercentage} {
		white-space: nowrap;
	}

	${({ theme }) => theme.breakpoints.down('xl')} {
		flex-basis: 40%;
		width: 40%;
	}

	${({ theme }) => theme.breakpoints.down('sm')} {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: var(--spacing);
		width: 100%;
	}
`

const ConfigurableOptionsWrapper = styled('div')`
	> div > div > label,
	> div > a {
		display: none;
	}

	.ProductOptions {
		&.select {
			margin-top: 0;
			padding: 0;
			> .MuiSelect-select {
				${({ theme }) => theme.typography.button};
				color: var(--color-primary);
				padding: 18px 24px !important;
				text-align: center;
			}
			.MuiSelect-icon {
				display: none;
			}
			.MuiOutlinedInput-notchedOutline {
				border: 1px solid;
			}
		}
	}

	${({ theme }) => theme.breakpoints.down('lg')} {
		.ProductOptions {
			&.select {
				> .MuiSelect-select {
					font-size: ${({ theme }) => theme.typography.pxToRem(12)};
					padding: 14px 8px !important;
				}
			}
		}
	}
`

export {
	ButtonAddToCart,
	ButtonOutOfStock,
	TypographyStyled,
	PreOrderDescription,
	ButtonsActionWrapper,
	ConfigurableOptionsWrapper,
	Title,
}
